<template>
    <div class="MainAreaFooter"> 
        <div style="height: 40px;">
             
        </div>
        <t-row>
            <t-col :xs="0" :sm="1">
            </t-col>
            <t-col :xs="12" :sm="4">
                <div class="Navigation" style="padding-left: 40px;">
                    <h3 style="t">About us</h3>
                    <div style="width: 80%;">
                        <h5>Company</h5>
                        <div>CHALREMPUI TECHNOLOGIES (OPC) PRIVATE LIMITED</div>
                        <h5>Address</h5>
                        <div>#224, 3rd Floor, #80/3, Vijinapur Village, old madras road, rk Puram, Hobli, Bengaluru, 560016</div>
                        <h5>Email</h5>
                        <div>hitechsigma996@gmail.com</div>
                    </div>
                </div>
            </t-col>
            <t-col :xs="12" :sm="4">
                <div class="Navigation">
                    <ul>
                        <li><h3>SERVICES</h3></li>
                        <li v-for="(item,index) of list2" :key="index" class="router-link">
                            <router-link class="router-link" :to="{name:item.name}"> 
                                {{ item.title }}
                            </router-link>
                        </li> 
                    </ul>   
                </div>
            </t-col>

            <t-col :xs="12" :sm="3">
                <div class="Navigation">
                    <ul>
                        <li><h3>{{ $t('components_main_areaFooter.title3') }}</h3></li>
                        <li v-for="(item,index) of list3" :key="index" class="router-link">
                            <router-link class="router-link" :to="{name:item.name}"> 
                                {{ item.title }}
                            </router-link>
                        </li> 
                    </ul>   
                </div>
            </t-col>
        </t-row>
        <div style="height: 60px;">
        </div>
        <t-row>
            <t-col :xs="0" :sm="1">
            </t-col>
            <t-col :xs="12" :sm="11">
                <ul class="LinksSection">
                    <li v-for="(item,index) of list1" :key="index" style="line-height: 15px;">
                        <router-link class="router-link" :to="{name:item.name}"> 
                            {{ item.title }}
                        </router-link>
                    </li> 
                </ul> 
            </t-col>
        </t-row>

            
       
        <div style="height: 10px;">
             
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MainAreaFooterPage',
    data(){
          return{ 
            list1 : [
                {
                    title : 'About US',
                    name : 'About'
                },{
                    title : this.$t('components_main_areaFooter.Contact'),
                    name : 'Contact'
                },{
                    title : this.$t('components_main_areaFooter.PrivacyPolicy'),
                    name : 'PrivacyPolicy'
                },{
                    title : 'Condition Of Sales',
                    name : 'ConditionSales'
                },{
                    title : 'Disputes Resolution Process',
                    name : 'DisputesResolutionProcess'
                },{
                    title : this.$t('components_main_areaFooter.ReturnsAndRefunds'),
                    name : 'ReturnsAndRefunds'
                },{
                    title : 'Shipping Policy',
                    name : 'ShippingPolicy'
                }
            ],
            list2 : [
                {
                    title : 'About US',
                    name : 'About'
                },{
                    title : this.$t('components_main_areaFooter.Contact'),
                    name : 'Contact'
                }
            ],
            list3 : [
                {
                    title : this.$t('components_main_areaFooter.PrivacyPolicy'),
                    name : 'PrivacyPolicy'
                },{
                    title : 'Condition Of Sales',
                    name : 'ConditionSales'
                },{
                    title : 'Disputes Resolution Process',
                    name : 'DisputesResolutionProcess'
                },{
                    title : this.$t('components_main_areaFooter.ReturnsAndRefunds'),
                    name : 'ReturnsAndRefunds'
                },{
                    title : 'Shipping Policy',
                    name : 'ShippingPolicy'
                },{
                    title : 'Retention Policy',
                    name : 'RetentionPolicy'
                },{
                    title : 'Terms and conditions',
                    name : 'TermsAndConditions'
                }
            ]
          }
    },
    props: { 
    },
    components:{
    }
  }
  </script>
  
  <style scoped> 
    .MainAreaFooter{
        background-color: #e5e5e5;
    }
    li{
        list-style-type: none; /* 去掉圆点 */
        line-height: 40px;
    }
    .LinksSection{
        display: flex; /* 使用Flex布局使列表项横向显示 */
        flex-wrap: wrap; /* 设置换行 */
        padding-bottom: 10px;
        font-size: 10px;
    }
    .LinksSection li:not(:last-child) {
        border-right: 2px solid #cbbcbc;
        padding-right: 10px;
        margin-right: 10px; 
    }
    .Navigation{
        text-align: left;
    } 
    


  @media screen and (max-width: 768px) {
    /* 手机屏幕样式 */ 
  }
   
  @media screen and (min-width: 769px) {
    /* 平板或电脑屏幕样式 */ 
  }
  </style>
  